/** File to store all kinds of enums.
 * When directly referencing string values everywhere the codebase
 * gets polluted. Enums help readability and reduce accidental errors.
 */

// eslint-disable-next-line
export const EDIT_DISPLAY = {
  EMAIL: 'email',
  LINK: 'html',
  PDF: 'pdf',
  WECHAT: 'wechat',
  EMBED: 'embed',
  APPOINTMENT: 'appointment',
};

// eslint-disable-next-line
export const SYNC_TARGETS = {
  WEBSITE: 'WEBSITE',
};

// eslint-disable-next-line
export const APPOINTMENT_TYPES = {
  VIRTUAL: 'VI',
  LIVESTREAM: 'LS',
  IN_PERSON: 'IP',
  RECOMMENDATION: 'RE',
};

// eslint-disable-next-line
export const EMAIL_EVENTS = {
  click: 'Clicks',
  delivered: 'Delivered',
  open: 'Opens',
  bounce: 'Bounced',
  unsubscribe: 'Unsubscribed',
};

// eslint-disable-next-line
export const APPOINTMENT_EVENTS = {
  click: 'Clicks',
  like: 'Likes',
  invited: 'Invited',
  attended: 'Attended',
};

export const MIXPANEL_EVENTS = {
  editCreated: 'edit_created',
  createCollage: 'create-collage',
  addImage: 'add_image',
  groupCreated: 'group_created',
  newAppointment: 'new_appointment',
  signedIn: 'signed_in',
  signInAttempt: 'sign_in_attempt',
  signInFailure: 'sign_in_failure',
};
